import type { Component, ComputedRef } from 'vue';
import { computed, markRaw, reactive } from 'vue';

export interface Modal {
  component: Component|null;
  title?: string;
  subtitle?: string;
  isCloseable?: boolean;
  isClosingOnOutside?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  events?: any;
}

export interface NewModal extends Modal {
  component: Component;
}

export interface UseModal {
  modal: ComputedRef<Modal>,
  openModal: (options: NewModal) => void;
  closeModal: () => void;
}

const base: Modal = {
  component: null,
  props: {},
  events: {},
  title: '',
  subtitle: '',
  isCloseable: true,
  isClosingOnOutside: true,
};

interface State {
  modal: Modal
}

const state = reactive<State>({
  modal: base
});

export const modal = computed(() => state.modal);

export const useModal = (options: NewModal) => {
  const body = document.body;
  const modal = document.querySelector('dialog#modal') as HTMLDialogElement;

  if (body) {
    body.style.overflow = 'hidden';
    modal?.showModal();
  }

  const mergedOptions = { ...base, ...options };
  mergedOptions.component = markRaw(mergedOptions.component);

  state.modal = mergedOptions;
}

export const closeModal = () => {
  state.modal = base;

  const body = document.body;
  const modal = document.querySelector('dialog#modal') as HTMLDialogElement;

  if (body) {
    body.style.overflow = 'auto';
    modal?.close();
  }
};
